import type { Components } from '@mui/material';

import { type HorizonTheme } from './horizon-theme';

export const muiTableContainer: Components<HorizonTheme>['MuiTableContainer'] =
  {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: '2px',
        borderBottom: `1px solid ${theme.palette.gray300.main}`,
      }),
    },
  };
